// Site key CAPCTHA Cloudflare
export const SITE_KEY_CLOUDFLARE = process.env.REACT_APP_SITE_KEY_CLOUDFLARE;

//apply base url for axios
export const API_URL = process.env.REACT_APP_URL_STAGING;
export const ISLIVE_MERCHANT = process.env.REACT_APP_DOITPAY_MERCHANT_ISLIVE;

// countdown otp email
export const REGISTER_EMAIL_MINUTE = process.env.REACT_APP_REGISTER_EMAIL_MINUTE;
export const REGISTER_EMAIL_SECONDS = process.env.REACT_APP_REGISTER_EMAIL_SECONDS;

// Notification Tab Disabled or Enabled
export const NOTIFICATION_TAB = process.env.REACT_APP_DOITPAY_STATUS_NOTIFICATION
